<main class="profile">
  <form class="profile__form">
    <section class="profile__header">
      <a class="profile__pic" href="#"></a>
      <span class="profile__title">Иван</span>
    </section>
    <section class="profile__body">
      {{{email}}}
      {{{login}}}
      {{{firstName}}}
      {{{lastName}}}
      {{{nickname}}}
      {{{phone}}}
    </section>
    <section class="profile__footer">
      {{{btnSubmit}}}
      {{{btnChangePass}}}
      {{{btnClose}}}
    </section>
  </form>
  <div class="backTo">
    <button class="backTo__btn" type="button">Назад</button>
  </div>
</main>
